import { render, staticRenderFns } from "./StatusButton.vue?vue&type=template&id=491300b3&"
import script from "./StatusButton.vue?vue&type=script&lang=js&"
export * from "./StatusButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn})
